import { Timeline } from 'antd'
import { SvgCalendarDesignIcon } from 'app/assets/svg-assets'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { BORDER_RADIUS, PADDING } from 'parkway-web-common'
import styled from 'styled-components'
import { PatientJourneyItem } from './components'
import { PatientJourneyData } from './constant'

export const PatientJourneyLayout = () => {
  return (
    <RootWrapper>
      <Timeline>
        {PatientJourneyData.map((item, index) => {
          return (
            <Timeline.Item
              key={index}
              children={
                <BaseSpace>
                  <BaseRow gutter={[10, 10]} align={'middle'} >
                    <SvgCalendarDesignIconStyled opacity={0.7} />
                    <BaseCol>
                      <BaseText
                        children={item?.startDate}
                        opacity="0.7"
                        fontWeight="semibold"
                      />
                    </BaseCol>
                  </BaseRow>

                  <PatientJourneyItem item={item} />
                </BaseSpace>
              }
            />
          )
        })}
      </Timeline>
    </RootWrapper>
  )
}

const SvgCalendarDesignIconStyled = styled(SvgCalendarDesignIcon)`
  path {
    fill: ${convertedVariables.primaryColor};
  }
`
const RootWrapper = styled(BaseSpace)`
  padding: ${PADDING.md};
  background-color: #f9fafb; // need change
  border-radius: ${BORDER_RADIUS};
`
